import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import FamilyPeople from "./icons/settings/FamilyPeople";
import {Timeline as TimelineIcon} from "./icons/Timeline";
import Wallet from "./icons/Wallet";
import { Shopping } from "./icons/Shopping";
import InvestmentDashboard from "./icons/InvestmentDashboard";
import Research from "./icons/Research";
import Watchlist from "./icons/Watchlist";
import Report from "./icons/Report";
import SeniorDashboard from "./icons/settings/SeniorDashboard";
import Bills from "./icons/Bills";
import Menubar from "./icons/Menubar";
import { isPermission } from "../../../../Utils";
import NotificationsSenior from "./icons/settings/NotificationsSenior";
import { useTranslation } from "react-i18next";

const Bottom = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const elementRef = useRef(null);
  const isVisible = props.isMobileNav;
  const activeColor = props.state.theme.values.primaryColor;
  const defaultColor = props.state.theme.values.tertiaryGrayColor;

  useEffect(() => {
    if(window.innerWidth < 767 && !window.location.pathname.includes('parent/senior/')){
      const handleClickOutside = (event) => {
        setTimeout(() => {
          if(window.innerWidth < 767 && !window.location.pathname.includes('parent/senior/')){
            if(document.querySelector('.more-icons.dropdown')){
              if(document.querySelector('.more-icons.dropdown').classList.contains('show')){
                document.querySelector('body').classList.toggle('overflow-hidden');
                if(document.querySelector('.dashboard-wrapper .dashboard-right-article .dashboard-heading')){
                  document.querySelector('.dashboard-wrapper .dashboard-right-article .dashboard-heading').classList.toggle('no-background');
                }
              }
              else{
                document.querySelector('body').classList.remove('overflow-hidden');
                if(document.querySelector('.dashboard-wrapper .dashboard-right-article .dashboard-heading')){
                  document.querySelector('.dashboard-wrapper .dashboard-right-article .dashboard-heading')?.classList.remove('no-background');
                }
                document.querySelector('.adult-menu-toggle-items').classList.remove('show');
              }
            }
          }
        }, 50);
      };
  
      document.addEventListener('mousedown', handleClickOutside);
  
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
   
  }, [document.querySelector('.more-icons.dropdown.show')]);

  useEffect(() => {
    if(window.innerWidth < 767 && window.location.pathname.includes('parent/senior/')){
      const handleClickOutside = (event) => {
        setTimeout(() => {
          if(window.innerWidth < 767 && window.location.pathname.includes('parent/senior/')){
            if(document.querySelector('.senior-more-icons.dropdown').classList.contains('show')){
              document.querySelector('body').classList.toggle('overflow-hidden');
            }
            else{
              document.querySelector('body').classList.remove('overflow-hidden');
              document.querySelector('.senior-menu-toggle-items').classList.remove('show');
            }
          }
        }, 50);
      };
  
      document.addEventListener('mousedown', handleClickOutside);
  
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
   
  }, [document.querySelector('.senior-more-icons.dropdown.show')]);

  return (
    <>
      {props.sidebar === true &&
        <div className={`bottom-navigation-bar ${isVisible ? '' : 'hide'}`}>
          <ul>
            <li onClick={() => props.history.push('/parent/dashboard')} className={`${location.pathname === "/parent/dashboard" ? 'active' : ''}`}>
              <span className="svgIcon">
                <FamilyPeople color={location.pathname === "/parent/dashboard" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>
            {isPermission(props, 'MerchantLevelControls') === false &&
            <li onClick={() => props.history.push('/parent/shopping')} className={`${location.pathname === "/parent/shopping" ? 'active' : ''}`}>
              <span className="svgIcon">
                <Shopping color={location.pathname === "/parent/shopping" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>}
            {!isPermission(props, `Whitelabel`) === true &&
            <li onClick={() => props.history.push('/parent/wallet')} className={`${location.pathname === "/parent/wallet" ? 'active' : ''}`}>
              <span className="svgIcon">
                <Wallet color={location.pathname === "/parent/wallet" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>
            }
            {isPermission(props, `Whitelabel`) === true &&
            <li onClick={() => props.history.push('/parent/transfer')} className={`${location.pathname === "/parent/transfer" ? 'active' : ''}`}>
              <span className="svgIcon">
                <Wallet color={location.pathname === "/parent/transfer" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>
            }
            <li onClick={() => props.history.push('/parent/timeline')} className={`${location.pathname === "/parent/timeline" ? 'active' : ''}`}>
              <span className="svgIcon">
                <TimelineIcon color={location.pathname === "/parent/timeline" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>
            <div className={`more-icons dropdown ${(
                location.pathname === "/parent/chores" || 
                location.pathname === "/parent/charities" ||
                location.pathname === "/parent/education" ||
                location.pathname === "/parent/setting/dashboard"
              ) ? 'active' : ''}`}>
              <div className="menu-toggler dropdown-toggle" id="more-menu-bottom" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                ref={elementRef}
              >
                <Menubar color={(
                  location.pathname === "/parent/chores" || 
                  location.pathname === "/parent/charities" ||
                  location.pathname === "/parent/education" ||
                  location.pathname === "/parent/setting/dashboard"
                ) ? activeColor : defaultColor}/>
              </div>
              <div className="adult-menu-toggle-items menu-toggle-items dropdown-menu" aria-labelledby="more-menu-bottom">
                <div className="menu-container">
                  <li onClick={() => props.history.push('/parent/chores')}>{t('chores')}</li>
                  {isPermission(props, `Charity`) === true &&
                    <li onClick={() => props.history.push('/parent/charities')}>{t('charities')}</li>
                  }
                  <li onClick={() => props.history.push('/parent/education')}>{t('education')}</li>
                  <li onClick={() => props.history.push('/parent/setting/dashboard')}>{t('settings')}</li>
                </div>
              </div>
            </div>
          </ul>
        </div>
      }
      
      {props.sidebar === false || props.state.theme.values.navLocation === 'iFrame-Top' || props.state.theme.values.navLocation === 'Hamburger' &&
        <div className={`bottom-navigation-bar ${isVisible ? '' : 'hide'}`}>
          <ul>
            <li onClick={() => props.history.push('/parent/dashboard')} className={`${location.pathname === "/parent/dashboard" ? 'active' : ''}`}>
              <span className="svgIcon">
                <FamilyPeople color={location.pathname === "/parent/dashboard" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>
            {isPermission(props, 'MerchantLevelControls') === false &&
            <li onClick={() => props.history.push('/parent/shopping')} className={`${location.pathname === "/parent/shopping" ? 'active' : ''}`}>
              <span className="svgIcon">
                <Shopping color={location.pathname === "/parent/shopping" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>}
            {!isPermission(props, `Whitelabel`) === true &&
            <li onClick={() => props.history.push('/parent/wallet')} className={`${location.pathname === "/parent/wallet" ? 'active' : ''}`}>
              <span className="svgIcon">
                <Wallet color={location.pathname === "/parent/wallet" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>
            }
            {isPermission(props, `Whitelabel`) === true &&
            <li onClick={() => props.history.push('/parent/transfer')} className={`${location.pathname === "/parent/transfer" ? 'active' : ''}`}>
              <span className="svgIcon">
                <Wallet color={location.pathname === "/parent/transfer" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>
            }
            <li onClick={() => props.history.push('/parent/timeline')} className={`${location.pathname === "/parent/timeline" ? 'active' : ''}`}>
              <span className="svgIcon">
                <TimelineIcon color={location.pathname === "/parent/timeline" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>
            <div className={`more-icons dropdown ${(
                location.pathname === "/parent/chores" || 
                location.pathname === "/parent/charities" ||
                location.pathname === "/parent/education" ||
                location.pathname === "/parent/setting/dashboard"
              ) ? 'active' : ''}`}>
              <div className="menu-toggler dropdown-toggle" id="more-menu-bottom" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                ref={elementRef}
              >
                <Menubar color={(
                  location.pathname === "/parent/chores" || 
                  location.pathname === "/parent/charities" ||
                  location.pathname === "/parent/education" ||
                  location.pathname === "/parent/setting/dashboard"
                ) ? activeColor : defaultColor}/>
              </div>
              <div className="adult-menu-toggle-items menu-toggle-items dropdown-menu" aria-labelledby="more-menu-bottom">
                <div className="menu-container">
                  <li onClick={() => props.history.push('/parent/chores')}>{t('chores')}</li>
                  {isPermission(props, `Charity`) === true &&
                    <li onClick={() => props.history.push('/parent/charities')}>{t('charities')}</li>
                  }
                  <li onClick={() => props.history.push('/parent/education')}>{t('education')}</li>
                  <li onClick={() => props.history.push('/parent/setting/dashboard')}>{t('settings')}</li>
                </div>
              </div>
            </div>
          </ul>
        </div>
      }

      {props.investmentSidebar === true &&
        <div className={`bottom-navigation-bar ${isVisible ? '' : 'hide'}`}>
          <ul>
            <li onClick={() => props.history.push('/parent/investments/dashboard')} className={`${location.pathname === "/parent/investments/dashboard" ? 'active' : ''}`}>
              <span className="svgIcon">
                <InvestmentDashboard color={location.pathname === "/parent/investments/dashboard" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>
            <li onClick={() => props.history.push('/parent/investments/timeline')} className={`${location.pathname === "/parent/investments/timeline" ? 'active' : ''}`}>
              <span className="svgIcon">
                <TimelineIcon color={location.pathname === "/parent/investments/timeline" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>
            <li onClick={() => props.history.push('/parent/investments/research')} className={`${location.pathname === "/parent/investments/research" ? 'active' : ''}`}>
              <span className="svgIcon">
                <Research color={location.pathname === "/parent/investments/research" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>
            <li onClick={() => props.history.push('/parent/investments/watchlist')} className={`${location.pathname === "/parent/investments/watchlist" ? 'active' : ''}`}>

              <span className="svgIcon">
                <Watchlist color={location.pathname === "/parent/investments/watchlist" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>
            <li onClick={() => props.history.push('/parent/investments/reports')} className={` ${location.pathname === "/parent/investments/reports" ? 'active' : ''}`}>
              <span className="svgIcon">
                <Report color={location.pathname === "/parent/investments/reports" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>
          </ul>
        </div>
      }
      {props.seniorSidebar === true &&
        <div className={`bottom-navigation-bar ${isVisible ? '' : 'hide'}`}>
          <ul>
            <li onClick={() => props.history.push('/parent/senior/dashboard')} className={`${location.pathname === "/parent/senior/dashboard" ? 'active' : ''}`}>
              <span className="svgIcon">
                <SeniorDashboard color={location.pathname === "/parent/senior/dashboard" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>
            <li onClick={() => props.history.push('/parent/senior/spending')} className={`${location.pathname === "/parent/senior/spending" ? 'active' : ''}`}>
              <span className="svgIcon">
                <Shopping color={location.pathname === "/parent/senior/spending" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>
            <li onClick={() => props.history.push('/parent/senior/recurringBills')} className={`${location.pathname === "/parent/senior/recurringBills" ? 'active' : ''}`}>
              <span className="svgIcon">
                <Bills color={location.pathname === "/parent/senior/recurringBills" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>
            <li onClick={() => props.history.push('/parent/senior/notifications')} className={`${location.pathname === "/parent/senior/notifications" ? 'active' : ''}`}>
              <span className="svgIcon">
                <NotificationsSenior color={location.pathname === "/parent/senior/notifications" ? activeColor : defaultColor}/>
              </span>
              <span className="half-circle"></span>
            </li>
            <div className={`senior-more-icons dropdown ${(
                location.pathname === "/parent/senior/accounts" || 
                location.pathname === "/parent/senior/protection" ||
                location.pathname === "/parent/senior/financialCaregivers"
              ) ? 'active' : ''}`}>
              <div className="menu-toggler dropdown-toggle" id="senior-more-menu-bottom" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                ref={elementRef}
              >
                <Menubar color={(
                  location.pathname === "/parent/senior/accounts" || 
                  location.pathname === "/parent/senior/protection" ||
                  location.pathname === "/parent/senior/financialCaregivers"
                ) ? activeColor : defaultColor}/>
              </div>
              <div className="senior-menu-toggle-items menu-toggle-items dropdown-menu" aria-labelledby="senior-more-menu-bottom">
                <div className="menu-container">
                  <li onClick={() => props.history.push('/parent/senior/accounts')}>{t('accounts')}</li>
                  <li onClick={() => props.history.push('/parent/senior/protection')}>{t('protection')}</li>
                  <li onClick={() => props.history.push('/parent/senior/financialCaregivers')}>{t('caregiver')}</li>
                  <li onClick={() => props.history.push('/parent/senior/settings')}>{t('settings')}</li>
                </div>
              </div>
            </div>
          </ul>
        </div>
      }

    </>
  );
};

export default Bottom;
